module.exports = __webpack_public_path__ + "static/img/login-box-bg.11b9112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login-box-bg.png
// module id = xDmk
// module chunks = 1